export const DAILY_DEVICE_AUDIT_REQUEST = "DAILY_DEVICE_AUDIT_REQUEST"
export const DAILY_DEVICE_AUDIT_RESULT = "DAILY_DEVICE_AUDIT_RESULT"